import type { ChatbotSize } from 'types/chatbot';
import type { ChatbotState } from '../index';

export const setSize = (state: ChatbotState, { payload }: { payload: ChatbotSize }) => {
  state.size = payload;
};
